import { req, Request } from '../Repository';
import { setFullToken, checkTokenHeaders } from '../apiHelper';

const resource = '/user';

export default {
    //NOT LOG IN
    authUser: (email, password) => {
        return req().then((token) => {
            return Request.post(
                `${resource}/auth`,
                JSON.stringify({
                    emailOrUserName: email,
                    password,
                })
            );
        });
    },

    validateXdentCode: (code, eula) => {
        return req().then((token) => {
            return Request.get(`${resource}/validatexdentcode?code=${code}&eulaAgreed=${eula}`);
        });
    },

    registerByXdentCode: (email, code) => {
        return req().then((token) => {
            return Request.post(
                `${resource}/registerbyxdentcode`,
                JSON.stringify({
                    emailOrUserName: email,
                    code,
                })
            );
        });
    },

    // authUserByToken - probably not used
    // authUserByToken: tempToken => {
    //     return Repository().post(`${resource}/authbytoken`, tempToken);
    // },

    requestNewPassword: (email, recaptchaResponse) => {
        return Request.post(
            `${resource}/requestforgottenpasswordmessage`,
            JSON.stringify({
                emailOrUsername: email,
                recaptchaResponse,
            })
        );
    },
    setForgottenPassword: (email, password, emailToken, recaptcha) => {
        return Request.post(
            `${resource}/setforgottenpassword`,
            JSON.stringify({
                emailOrUsername: email,
                password,
                token: emailToken,
                recaptchaResponse: recaptcha,
            })
        );
    },

    confirmUserByCode: (code) => {
        return Request.get(`${resource}/confirmuserbyregistrationcode?code=${code}`);
    },

    //NEEDS TOKEN TO AUTHORIZE
    getUserInfo: (token) => {
        return req(token).then((token) => {
            return Request.get(`${resource}`, token);
        });
    },

    updateUser: ({ userName, email, twoFactorEnabled, phoneNumber, nameIdentifier, oldPassword, newPassword, token, phonePrefixId }) => {
        return req(token).then((token) => {
            return Request.post(
                `${resource}/updateuser`,
                JSON.stringify({
                    userName,
                    email,
                    twoFactorEnabled,
                    phoneNumber,
                    nameIdentifier,
                    oldPassword,
                    newPassword,
                    phonePrefixId,
                }),
                token
            );
        });
    },

    // deleteUser - probably not used
    // deleteUser: token => {
    //     return Repository().delete(`${resource}`, checkTokenHeaders(token));
    // },

    // patchUser - probably not used
    // patchUser: (arr, token) => {
    //     return Repository().patch(
    //         `${resource}`,
    //         [JSON.stringify(arr)],
    //         checkTokenHeaders(token)
    //     );
    // },

    // sendUserNewPassword - probably not used
    // sendUserNewPassword: (email, token) => {
    //     return Repository().post(
    //         `${resource}/forgottenpassword`,
    //         email,
    //         checkTokenHeaders(token)
    //     );
    // },

    changeUserPassword: (currentPassword, newPassword, token) => {
        return req(token).then((token) => {
            return Request.post(
                `${resource}/changepassword`,
                JSON.stringify({
                    code: currentPassword,
                    newPassword,
                }),
                token
            );
        });
    },
    pairUserWithCompany: (code, token) => {
        return req(token).then((token) => {
            return Request.get(`${resource}/pairuserwithclinic?code=${code}`, token);
        });
    },
    changeEmail: (id, oldEmail, newEmail, password, token) => {
        return req(token).then((token) => {
            return Request.post(
                `${resource}/updateemail`,
                JSON.stringify({
                    id,
                    oldEmail,
                    newEmail,
                    password,
                    token: '',
                }),
                token
            );
        });
    },
    getLanguages: async (token = JSON.parse(localStorage.getItem('token'))) => {
        let { data } = await req(token).then((token) => {
            return Request.get(`${resource}/getlanguages`, token);
        });
        return data;
    },
    changeLanguage: (idLanguage, token) => {
        return req(token).then((token) => {
            return Request.get(`${resource}/changeLanguage?languageId=${idLanguage}`, token);
        });
    },
    //FINISH REGISTRATION
    confirmUserCredentials: (emailOrUserName, password, token) => {
        return req(token).then((token) => {
            return Request.post(
                `${resource}/confirmusercredentials`,
                JSON.stringify({
                    emailOrUserName,
                    password,
                }),
                token
            );
        });
    },
};
